import { getPageAllowedRoles } from "../../config/roles";
import { fullWidth } from "../../blocks/layout/columnSpans";
import { PageDefinition } from "../pageDefinition.types";
import { DataImportPanel } from "./DataImportPanel";

/** Starting a contact import from a CSV file, and following one through to its result. */
export const dataImportPageDefinition: PageDefinition = {
  path: "/data-import",
  title: "Data Import",
  allowedRoles: getPageAllowedRoles("data-import"),
  back: { route: "/data-imports", title: "Back to data imports" },
  rows: [
    {
      id: "row-import",
      panels: [
        {
          id: "panel-import",
          title: "Import",
          span: fullWidth,
          component: DataImportPanel,
        },
      ],
    },
  ],
};
